const API_BASE_URL = "https://api.shahrizada.ru";
// const API_BASE_URL = "http://localhost:3001";

export default API_BASE_URL;
